var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m8.373 15.707 7-7L16.082 8l-.707-.707-7-7L6.96 1.707 12.252 7H0v2h12.252L6.96 14.293l1.414 1.414Z",
  clipRule: "evenodd"
})));
export default SvgIconArrow;